<template>
  <div class="daform-section-header-fallback" v-if="field">
    <i v-if="field.icon" :class="field.icon"></i>
    <span>{{ field.label }}</span>
  </div>
</template>

<script>
export default {
  props: ["field", "fields"],
};
</script>

<style scoped>
.daform-section-header-fallback {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  padding: 8px 0 4px;
}
</style>
